import _ from "lodash";
import update from "immutability-helper";
import client from "lib/apolloClient/client";
import { getChildrenQuery } from "modules/CommonQuery";
import { getPlatformUserDetailsQuery } from "FamilyProfile/modules/FamilyProfileQueries";
import { PARENT } from "Constants/stringConstants";
import { setToastMsg, switchChild } from "routes/modules/LoginModule";
import { USER_TYPE_ENTITY_MAPPING } from "Constants";
import {
  declineFamilyInvitationMutation,
  editUserMutation,
} from "./FamilyProfileMutations";
import { getChildrenQueryVariables } from "./Utils";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import { goToStudentProfileRoute } from "modules/NavigationModule";

const initialState = {
  familyMemberInfo: {
    firstName: "",
    lastName: "",
    preferredName: "",
    prefix: "",
    suffix: "",
    pronouns: "",
    profileImage: "",
    email: "",
  },
};

export const NAME = "FAMILY_PROFILE";
export const UPDATE_FAMILY_PROFILE_INFO = `UPDATE_FAMILY_PROFILE_INFO ${NAME}`;

export const updateFamilyProfileInfo = data => {
  return {
    type: UPDATE_FAMILY_PROFILE_INFO,
    data,
  };
};

export const updateFamilyInfo = ({ parentId }) => {
  return async (dispatch, getState) => {
    const userEntityType = _.get(
      USER_TYPE_ENTITY_MAPPING[PARENT],
      "entityType",
      ""
    );

    const userData = _.get(getState(), "familyProfile.familyMemberInfo", {});

    try {
      await client.mutate({
        mutation: editUserMutation,
        variables: {
          id: parentId,
          ...userData,
        },
        refetchQueries: [
          {
            query: getPlatformUserDetailsQuery,
            variables: {
              id: parentId,
              type: userEntityType,
            },
          },
        ],
      });

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:saved_successfully",
        })
      );
    } catch (error) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const declineFamilyInvitation = ({ parentId, childId }) => {
  return async (dispatch, getState) => {
    const portalType = "PLANNER";
    const userInfo = getUserInfo({ portalType });
    const userId = _.get(userInfo, "id");
    const user_type = _.get(userInfo, "user_type");
    const organizationId = _.get(userInfo, "org_id");

    try {
      await client.mutate({
        mutation: declineFamilyInvitationMutation,
        variables: {
          input: {
            parentId,
            childId,
          },
        },
        refetchQueries: [
          {
            query: getChildrenQuery,
            variables: getChildrenQueryVariables({
              familyMemberId: parentId,
              user_type,
              organizationId,
              userId,
              includeInvitedStudents: true,
            }),
          },
        ],
        awaitRefetchQueries: true,
      });

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:invitation_declined",
        })
      );
    } catch (error) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const switchChildByUserType = ({ userType, child }) => {
  return dispatch => {
    if (userType === PARENT) {
      return dispatch(switchChild({ childData: child }));
    }
  };
};

export const switchChildAndNavigate = ({
  child,
  userType,
  curriculumPrograms,
}) => {
  return async dispatch => {
    await dispatch(switchChildByUserType({ userType, child }));
    dispatch(
      goToStudentProfileRoute({
        studentId: child.id,
        currentCurriculumProgramId: _.get(_.first(curriculumPrograms), "id"),
      })
    );
  };
};

const REDUCER_HANDLERS = {
  [UPDATE_FAMILY_PROFILE_INFO]: (state, action) => {
    const updatedFields = action.data;
    return update(state, {
      familyMemberInfo: { $merge: updatedFields },
    });
  },
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
